import { MutationHookOptions, useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { useCallback } from 'react';
import {
  ChangeClientPassword,
  ChangeClientPasswordVariables,
} from './__generated__/ChangeClientPassword';

const CHANGE_CLIENT_PASSWORD_MUTATION = gql`
  mutation ChangeClientPassword($input: ClientPasswordChangeInput!) {
    changeClientPassword(input: $input) {
      id
      email
    }
  }
`;

export const useChangeClientPasswordMutation = (
  options?: MutationHookOptions<
    ChangeClientPassword,
    ChangeClientPasswordVariables
  >,
) => {
  const onCompleted = options?.onCompleted;
  return useMutation<ChangeClientPassword, ChangeClientPasswordVariables>(
    CHANGE_CLIENT_PASSWORD_MUTATION,
    {
      ...options,
      onCompleted: useCallback(
        (data) => {
          onCompleted?.(data);
        },
        [onCompleted],
      ),
    },
  );
};

export default CHANGE_CLIENT_PASSWORD_MUTATION;
